import React from 'react';
import ScrollLockedAvianSequence from '../sequence/ScrollLockedAvianSequence';

interface DesktopViewProps {
  currentSection: number;
  sections: Array<{
    id: string;
    Component: React.ComponentType<{ isActive?: boolean }>;
  }>;
}

// * [COMPONENT] Desktop presentation view with discrete scroll-locked canvas sequence
// ? Replaces continuous document flow on desktop with 5 checkpoint discrete frame sequence
const DesktopView: React.FC<DesktopViewProps> = () => {
  return (
    <div className="app desktop-layout">
      {/* * Discrete 2D canvas sequence engine pinned to viewport */}
      <main className="main-content" style={{ overflow: 'hidden' }}>
        <ScrollLockedAvianSequence />
      </main>
    </div>
  );
};

export default DesktopView;

